import {  
    loadUserPermissionsRolesDataInProgress,
    loadUserPermissionsRolesDataSuccess,
    loadUserPermissionsRolesDataFailure,
    loadUserPermissionsRolesNotFound,
  } from "../state/userpermissions/actions";
import configData from "../config.json";
import { oktaAuth } from '../auth/okta';
import { errorSweetAlert } from "../components/SweetAlertMessages";
const serverBasePath=configData.SERVER_API_URL;
  
export const getUserPermissionRolesData = () => async (dispatch) => {
    const token = oktaAuth.getAccessToken();
    if (!token) throw new Error('No access token');
    try {
        dispatch(loadUserPermissionsRolesDataInProgress());
        const response  = await fetch(serverBasePath+"/user/getUserAndRolePermissions",
        {     
            method: "GET",
            headers: {
                Authorization: 'Bearer ' + token,
                'Content-Type': 'application/json',
            },
        });
        const data = await response.json();
        if(response.status === 404){
            dispatch(loadUserPermissionsRolesNotFound(data));
            return;
        }
        dispatch(loadUserPermissionsRolesDataSuccess(data));
    } catch (e) {       
        dispatch(loadUserPermissionsRolesDataFailure());
        errorSweetAlert(e);
    }
};
  
  